import React from 'react';
import { Input, Pagination } from 'components';
import { RootState } from 'reducers';
import { Globals } from 'utils';
import { connect } from 'react-redux';
import { CloseIcon } from 'assets/icons';
import { ChatService } from 'services';

interface Props extends RootState {
  onClose?: any;
  item?: any;
  onSubmit?: any;
}

// Antes este screen reusaba `screens/admin/revision/modal-assignament.tsx` tal
// cual, que llamaba a RevisionService.admin.getLawyers/assignLawyer -- un
// endpoint pensado para Revisión (filtra por UserServicePrice + document_id).
// Como un Chat no tiene document_id, ese componente lo hardcodeaba a `5`, así
// que la lista de abogados nunca reflejaba quiénes realmente pueden atender
// Chat (UserArea.with_chat = true). Este modal es la versión propia de Chat,
// sin ese campo, contra los endpoints nuevos de admin/chats.
class ModalAssignament extends React.Component<Props> {
  timer: any = undefined;

  state = {
    form: {
      search: '',
    },
    page: 1,
    last_page: 1,
    lawyers: [],
  };

  async componentDidMount() {
    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    // Los chats nuevos de cliente no tienen área: el API lista a todos los
    // abogados habilitados para chat cuando no se envía area_id.
    const { area_id } = this.props.item;

    const res: any = await ChatService.admin.getLawyers({
      ...(area_id ? { area_id } : {}),
      page: this.state.page,
      ...this.state.form,
      withoutLoading,
    });

    this.setState({
      lawyers: res?.rows || [],
      last_page: res?.count,
    });
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  submit = async (lawyer: any) => {
    try {
      if (!this.props.item) return;
      if (this.props.onSubmit) {
        this.props.onSubmit(lawyer);
      } else {
        const chatId = this.props.item?.id;
        const lawyerId = lawyer?.id;

        await ChatService.admin.assignLawyer({
          chat_id: chatId,
          lawyer_id: lawyerId,
        });
        this.props.onClose();
        Globals.showSuccess('Se ha asignado el abogado correctamente');
      }
    } catch (error) {}
  };

  render() {
    return (
      <div id='modal-assign-lawyer'>
        <div className='row'>
          <div className='col-md-6'>
            <h3>Asignar abogado</h3>
          </div>
          <div className='col-md-6 text-right'>
            <button className='btn btn-close' onClick={() => this.props.onClose()}>
              <img src={CloseIcon} />
            </button>
          </div>
        </div>
        <div className='container-input'>
          <Input
            value={this.state.form.search}
            name='search'
            placeholder='Nombre'
            className='input-table'
            onChange={(e: any) => {
              clearTimeout(this.timer);
              this.timer = setTimeout(() => {
                this.load(true);
              }, 1000);
              this.change(e);
            }}
          />
        </div>
        <div className='white-container'>
          {this.state.lawyers.map((item: any) => {
            return (
              <button className='btn-lawyer' onClick={() => this.submit(item)}>
                <span>{item?.full_name}</span>
                <span>{item?.format_lawyer_document}</span>
              </button>
            );
          })}
        </div>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(ModalAssignament);
